import React, {useEffect, useRef, useState} from 'react';
import {useLocation, useParams} from "react-router-dom";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Tabs} from "@mui/material";
import Box from "@mui/material/Box";
import CloudOptionsMaterialModule from "../../../components/UI/modul/mainoptions/CloudOptionsMaterialModule";
import GroupMaterialService from "../../../API/orders/orders/organization/GroupMaterialService";
import MaterialOrganizationOptionService
    from "../../../API/orders/warehouse/material/MaterialOrganizationOptionService";
import CurrentOptionsMaterialModule from "../../../components/UI/modul/mainoptions/CurrentOptionsMaterialModule";
import UserManufacturerMaterialCloudService
    from "../../../API/material-cloud/user/UserManufacturerMaterialCloudService";
import UserMaterialMaterialCloudService from "../../../API/material-cloud/user/UserMaterialMaterialCloudService";
import AdminMaterialMaterialCloudService from "../../../API/material-cloud/admin/AdminMaterialMaterialCloudService";
import {authorizedAdmin, authorizedOrganization, constantsErrorMessages} from "../../../Constants";
import JobMetricCloudModul from "../../../components/UI/table/cloud/material/JobMetricCloudModul";
import MaterialItemSettings from "../../common/settings/MaterialItemSettings";
import {BreadcrumbsComponent} from "../../../components/UI/breadcrumb/BreadcrumbComponent";
import Typography from "@mui/material/Typography";
import {ButtonGroupTabBar} from "../../../components/UI/button/ButtonGroupTabBar";
import CheckIcon from "@mui/icons-material/Check";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import ModalAlert from "../../../components/UI/table/customer-detales/ModalAlert";
import MaterialWarehouseCloudMarketTable
    from "../../../components/UI/table/warehouse/material/materialwarehouse/MaterialWarehouseCloudMarketTable";
import CurrencyService from "../../../API/orders/warehouse/currency/AdminCurrencyService";
import MaterialTree from "../../../components/UI/tree/MaterialTree";
import ButtonExit from "../../../components/UI/button/ButtonExit";
import ButtonAdd from "../../../components/UI/button/ButtonAdd";
import GroupMaterialUtil from "../../../utils/orders/GroupMaterialUtil";
import AdminSuppliersService from "../../../API/material-cloud/admin/AdminSuppliersService";
import SupplierMaterialItemModule from "../../../components/UI/modul/mainoptions/SupplierMaterialItemModule";
import AdminSupplierMaterialCloudService from "../../../API/admin/AdminSupplierMaterial";
import CircularProgress from "@mui/material/CircularProgress";
import {useIsAccessGranted} from "../../../utils/useIsAccessGranted";
import SupplierService from "../../../API/orders/warehouse/supplier/SupplierService";

const AllMaterialItem = ({settings, settingsParams}) => {
        const profile = JSON.parse(localStorage.getItem("profile"))
        const isOrganization = profile?.userRoles.some(role => authorizedOrganization.includes(role.name))
        const isAdmin = profile?.userRoles.some(role => authorizedAdmin.includes(role.name))
        const tabCurrentOptionsVisible = profile?.userRoles.some(role => ['ORGANIZATION_USER_MATERIAL_SUPER_USER', "ROLE_ORGANIZATION_USER_SETTINGS", "ROLE_ORGANIZATION_SUPER_USER"].includes(role.name))
        const isAllowedEdit = useIsAccessGranted(["ROLE_ORGANIZATION_USER_MATERIAL_SUPER_USER"])

        const params = useParams();
        const location = useLocation();
        const isSettings = new URLSearchParams(location.search).size > 0;
        const [alertData, setAlertData] = useState({});

        const [data, setData] = useState(null);
        const [dataMOO, setDataMOO] = useState(null);
        const [change, setChange] = useState(null);
        const [group, setGroup] = useState(null);

        const [supplierList, setSupplierList] = useState(null);
        const [groupMaterialList, setGroupMaterialList] = useState([]);
        const [manufacturerList, setManufacturerList] = useState(null);
        const [unitsList, setUnitsList] = useState([])

        const [supplierMaterialCloudList, setSupplierMaterialCloudList] = useState(null);
        const [groupMaterialMaterialCloudList, setGroupMaterialMaterialCloudList] = useState(null);
        const [manufacturerMaterialCloudList, setManufacturerMaterialCloudList] = useState(null);

        const [supplierId, setSupplierId] = useState(null);
        const [manufacturerId, setManufacturerId] = useState(null);
        const [groupMaterialId, setGroupMaterialId] = useState(null);
        const [isDataMOO, setIsDataMOO] = useState(false);
        const [currencies, setCurrencies] = useState()
        const [currencyMap, setCurrencyMap] = useState(new Map);
        const [modalSelectGroup, setModalSelectGroup] = useState(false)

        const {id, baseUnit, typeMaterial} = settings ? settingsParams : params;
        const [tableOptions, setTableOptions] = useState({
            pageIndex: 0,
            pageSize: 100,
            totalElements: 0,
            searchData: ""
        })
        const tableOptionsHandle = (nextState, currTab) => {
            setTableOptions(nextState)
            if (nextState.pageSize !== tableOptions.pageSize) {
                EditLocalStoragePagesData(`/all-materials+${tab}`, "pageSize", nextState.pageSize)
            }
        }
        const handleModalAlert = (message, type = "error") => {
            setAlertData({
                type: type,
                open: true,
                message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
            })
        }

        const [dataMaterialWholeData, setDataMaterialWholeData] = useState(null);
        const [dataMaterialMinStripeData, setDataMaterialMinStripeData] = useState(null);
        const [dataMaterialFixedStripeData, setDataMaterialFixedStripeData] = useState(null);

        const handleSubmitUpdateMainOptions = () => {
            const currentSupplierId = supplierId === null ? data.defaultSupplier?.id || null : supplierId;
            const currentManufacturerId = manufacturerId == null ? data.manufacturer?.id : manufacturerId;
            const currentGroupMaterialId = groupMaterialId == null ? data.groupMaterial?.id : groupMaterialId;

            AdminMaterialMaterialCloudService.updateMainOptions(data, currentSupplierId, currentManufacturerId, currentGroupMaterialId,
            ).then(function (response) {
                let data = response.data;
                handleUpdate(data)
                handleModalAlert("Данные изменены", 'success')
            })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        }

        const handleSubmitUpdateCurrentOptions = () => {
            const currentSupplierId = supplierId === null ? dataMOO.defaultSupplier?.id : supplierId;
            const currentManufacturerId = manufacturerId == null ? dataMOO.manufacturer?.id : manufacturerId;
            const currentGroupMaterialId = groupMaterialId == null ? dataMOO.groupMaterial?.id : groupMaterialId;

            const payload = {
                ...dataMOO,
                count: dataMOO?.typeMaterial === "SLAB" ? (dataMOO.count ?? 1) : null
            }
            MaterialOrganizationOptionService.updateCurrentOptions(payload, currentSupplierId, currentManufacturerId, currentGroupMaterialId,
            ).then(function (response) {
                let data = response.data;
                handleUpdateMOO(data)
                handleModalAlert("Данные изменены", 'success')
            })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        }

        const addMOOByMaterialId = (currentGroup) => {
            MaterialOrganizationOptionService.createByMaterial(id, currentGroup?.id).then(function (response) {
                let data = response.data;
                groupMaterialList.push(data.groupMaterial);
                setGroupMaterialId([...groupMaterialList]);
                setDataMOO(data)
                setModalSelectGroup(false)
                setIsDataMOO(data !== null && data !== undefined && data !== '');
                handleModalAlert("Данные добавлены", 'success')
            })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        }

        const handleUpdateMOO = (values) => {
            setIsDataMOO(values);
        };

        const handleUpdate = (values) => {
            setData(values);
        };

        const [tab, setTab] = useState(0);

        const getStartPageSize = () => {
            const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
            return pagesData["/all-materials"]?.tab
        }

        const handleChangeTab = (tab) => {
            setTab(tab)
            getTabsData(tab)
            EditLocalStoragePagesData(`/all-materials`, "tab", tab)
        }
        const getTabsData = (tab) => {
            const tabsData = JSON.parse(localStorage.getItem('pagesData')) || {}
            const pageSize = tabsData[`/all-materials`]?.pageSize
        }
        const firstRender = useRef(true);
        const [isLoading, setIsLoading] = useState(true);
        const getDataFromBackendByTabs = (savedTab) => {
            if ((savedTab === 0) && (!manufacturerMaterialCloudList || !supplierMaterialCloudList)) {
                Promise.all(isAdmin ? [UserManufacturerMaterialCloudService.getAll(), AdminSuppliersService.get()] : [UserManufacturerMaterialCloudService.getAll()]).then((values) => {
                    setManufacturerMaterialCloudList(values[0]?.data);
                    setSupplierMaterialCloudList(values[1]?.data);
                }).catch(function (error) {
                    handleModalAlert(error);
                }).finally(() => setIsLoading(false))
            } else if (savedTab === 1 && (!supplierList || !manufacturerList || !dataMOO || !isDataMOO)) {
                Promise.all([MaterialOrganizationOptionService.getForCloudCatalog(id), UserManufacturerMaterialCloudService.getAll(), SupplierService.get()]).then((values) => {
                    setIsDataMOO(values[0]?.data !== null && values[0]?.data !== undefined && values[0]?.data !== '');
                    setDataMOO(values[0]?.data);
                    setManufacturerList(values[1]?.data);
                    setSupplierList(values[2]?.data);
                }).catch(function (error) {
                    handleModalAlert(error);
                }).finally(() => setIsLoading(false))
            } else if (savedTab === 2 && (!dataMaterialWholeData || !dataMaterialMinStripeData || !dataMaterialFixedStripeData)) {
                Promise.all([AdminSupplierMaterialCloudService.getAllCurrentWholeByMaterialId(id), AdminSupplierMaterialCloudService.getAllCurrentByMaterialIdMinStripe(id), AdminSupplierMaterialCloudService.getAllCurrentByMaterialIdFixedStripe(id)]).then((values) => {
                    setDataMaterialWholeData(values[0]?.data);
                    setDataMaterialMinStripeData(values[1]?.data);
                    setDataMaterialFixedStripeData(values[2]?.data);
                }).catch(function (error) {
                    handleModalAlert(error);
                }).finally(() => setIsLoading(false))
            } else {
                setIsLoading(false)
            }
        }

        useEffect(() => {
            setIsLoading(true)
            const savedTab = getStartPageSize() || tab
            if (firstRender.current) {
                profile && CurrencyService.getAll()
                    .then(function (response) {
                        const data = response.data;
                        setCurrencies(data)
                        data.forEach((c) => {
                            currencyMap.set(c.id, c);
                        });
                    }).catch(function (error) {
                        handleModalAlert(error)
                    })
                UserMaterialMaterialCloudService.getWithAllPrices(id).then(function (response) {
                    let data = response.data;
                    setData(data)
                    setGroup(data.groupMaterial)
                    firstRender.current = false
                    getTabsData(savedTab)
                    savedTab === tab ? getDataFromBackendByTabs(savedTab) : setTab(savedTab)
                })
                    .catch(function (error) {
                        handleModalAlert(error);
                    });
            } else {
                getDataFromBackendByTabs(savedTab)
            }
        }, [tab]);

        const renderContent = () => {
            switch (tab) {
                case 0:
                    return <CloudOptionsMaterialModule
                        data={data}
                        setData={setData}
                        supplierList={supplierMaterialCloudList}
                        groupMaterialList={groupMaterialMaterialCloudList}
                        manufacturerList={manufacturerMaterialCloudList}
                        isSettings={isSettings}
                        handleSubmit={handleSubmitUpdateMainOptions}
                        setSupplierId={setSupplierId}
                        setManufacturerId={setManufacturerId}
                        setGroupMaterialId={setGroupMaterialId}
                        baseUnit={baseUnit}
                        changeOptionsDisabled={!isAdmin}
                        handleModalAlert={handleModalAlert}
                        typeMaterial={typeMaterial}
                    />
                case 1:
                    return <CurrentOptionsMaterialModule
                        data={dataMOO}
                        setData={setDataMOO}
                        supplierList={supplierList}
                        groupMaterialList={groupMaterialList}
                        manufacturerList={manufacturerList}
                        handleSubmit={handleSubmitUpdateCurrentOptions}
                        setSupplierId={setSupplierId}
                        setManufacturerId={setManufacturerId}
                        setGroupMaterialId={setGroupMaterialId}
                        baseUnit={baseUnit}
                        addMaterial={() => setModalSelectGroup(true)}
                        isDataMOO={isDataMOO}
                        changeOptionsDisabled={!isAllowedEdit}
                    />
                case 2:
                    return <SupplierMaterialItemModule
                        id={id}
                        materialId={id}
                        baseUnit={baseUnit}
                        typeMaterial={typeMaterial}
                        dataMaterialWholeData={dataMaterialWholeData}
                        dataMaterialMinStripeData={dataMaterialMinStripeData}
                        dataMaterialFixedStripeData={dataMaterialFixedStripeData}
                        setDataMaterialWholeData={setDataMaterialWholeData}
                        setDataMaterialMinStripeData={setDataMaterialMinStripeData}
                        setDataMaterialFixedStripeData={setDataMaterialFixedStripeData}
                        allPrice={true}
                        create={AdminSupplierMaterialCloudService.createByMaterialOrganizationOption}
                        update={AdminSupplierMaterialCloudService.update}
                        urlArchiveSM={`${isAdmin ? '/all-materials' : '/organization'}/supplier-material-archive-item`}
                        urlArchiveMS={`${isAdmin ? '/all-materials' : '/organization'}/supplier-material-min-archive-item`}
                        urlArchiveFS={`${isAdmin ? '/all-materials' : '/organization'}/supplier-material-fixed-archive-item`}
                        addArchive={AdminSupplierMaterialCloudService.sendToArchive}
                        isFixPrice={false}
                        currencyMap={currencyMap}
                        tableOptions={tableOptions}
                        tableOptionsHandle={tableOptionsHandle}
                        handleModalAlert={handleModalAlert}
                        isAdmin={isAdmin}
                    />
                case 3:
                    return <JobMetricCloudModul
                        id={id}
                        handleModalAlert={handleModalAlert}
                        notAuthorized={!profile}
                        cloudModuleFromHeader={!isSettings}
                        isAdmin={isAdmin}
                        readOnly={!isAdmin}
                        typeMaterial={typeMaterial}
                    />
                case 4:
                    return <MaterialWarehouseCloudMarketTable
                        materialId={id}
                        currencies={currencies}
                        typeMaterial={typeMaterial}
                    />
            }
        }
        return (
            isLoading ?
                <Box sx={{
                    height: "100vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <CircularProgress disableShrink/>
                </Box> : <div>
                    {settings ? <MaterialItemSettings
                            data={data}
                            dataMOO={dataMOO}
                            setData={setData}
                            supplierList={supplierList}
                            groupMaterialList={groupMaterialList}
                            manufacturerList={manufacturerMaterialCloudList}
                            handleSubmit={handleSubmitUpdateCurrentOptions}
                            setSupplierId={setSupplierId}
                            setManufacturerId={setManufacturerId}
                            setGroupMaterialId={setGroupMaterialId}
                            baseUnit={baseUnit}
                            isMaterialOrganizationOption={true}
                            isDataMOO={true}
                        /> :
                        <Box sx={{padding: "0 30px"}}>
                            <BreadcrumbsComponent
                                page={data?.name}
                                path={isSettings ? [{name: "Главная", href: "/"}, {
                                    name: "Настройки",
                                    href: "/settings"
                                }] : [{name: "Главная", href: "/"}]}/>
                            <Box sx={{display: "flex", flexDirection: "column", gap: "32px"}}>
                                <Box sx={{display: "flex", flexDirection: "column", gap: "16px"}}>
                                    <Typography component="p" sx={{fontSize: "24px", fontWeight: 700}}>
                                        {data?.name}
                                    </Typography>
                                </Box>
                                <ButtonGroupTabBar activeTab={tab}>
                                    <Button tabIndex={0} onClick={(e) => handleChangeTab(0)}>
                                        <CheckIcon/>Облако
                                    </Button>
                                    {tabCurrentOptionsVisible && <Button tabIndex={1} onClick={(e) => handleChangeTab(1)}>
                                        <CheckIcon/>Текущие
                                    </Button>}
                                    {isAdmin && <Button tabIndex={2} onClick={(e) => handleChangeTab(2)}>
                                        <CheckIcon/>Поставщики
                                    </Button>}
                                    <Button tabIndex={3} onClick={(e) => handleChangeTab(3)}>
                                        <CheckIcon/>Перечень работ
                                    </Button>
                                    {isAdmin || isOrganization && <Button tabIndex={4} onClick={(e) => handleChangeTab(4)}>
                                        <CheckIcon/>Рынок остатков
                                    </Button>}
                                </ButtonGroupTabBar>
                                {renderContent()}
                            </Box>
                        </Box>
                    }
                    <ModalAlert data={alertData} onClose={() => setAlertData((alert) => {
                        return {...alert, open: false}
                    })}/>
                    <ModalConfirm
                        modalOpen={modalSelectGroup}
                        handleSubmit={addMOOByMaterialId}
                        handleClose={() => setModalSelectGroup(false)}
                        handleModalAlert={handleModalAlert}
                        dataForGroup={{typeMaterial: data?.typeMaterial, subTypeMaterial: data?.subTypeMaterial}}
                    />
                </div>
        );
    }
;
const ModalConfirm = ({modalOpen, handleClose, handleSubmit, handleModalAlert, dataForGroup}) => {
    const [currentGroup, setCurrentGroup] = useState(null)
    const [dataTree, setDataTree] = useState(null)

    useEffect(() => {
        modalOpen && GroupMaterialService.getAllByOrganization().then((response) => {
            const buildTreeGroups = GroupMaterialUtil.buildTreeGroups(response.data);
            setDataTree(buildTreeGroups);
        }).catch(function (error) {
            handleModalAlert(error)
        });

    }, [modalOpen]);

    return (
        <div>
            <Dialog open={modalOpen} onClose={handleClose} PaperProps={{
                style: {
                    height: "600px"
                }
            }}>
                <DialogTitle textAlign="center">Выбрать группу</DialogTitle>
                <DialogContent>
                    {dataTree && <MaterialTree
                        data={dataTree}
                        currentGroup={currentGroup}
                        setCurrentGroup={setCurrentGroup}
                        readOnly={true}
                    />}
                </DialogContent>
                <DialogActions sx={{p: '1.25rem'}}>
                    <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                        <ButtonExit text={"Отменить"} onClick={handleClose}/>
                        <ButtonAdd text={"Выбрать"} disabled={!currentGroup}
                                   onClick={() => handleSubmit(currentGroup)}/>
                    </div>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default AllMaterialItem;